import React from 'react';
import PropTypes from 'prop-types';
import keyMirror from 'keymirror';

import connectToStores from '../../../helpers/connectToStores';
import Order from '../../../records/Order';
import OrderActions from '../../../actions/OrderActions';
import OrderStore from '../../../stores/OrderStore';
import PaymentStore from '../../../stores/PaymentStore';
import ThreeDSecure from '../../payment/ThreeDSecure';
import TokenStore from '../../../stores/TokenStore';
import { makeUrl } from '../../../lib/APIClient';
import config from '../../../config';
import CustomerActions from '../../../actions/CustomerActions';

export const ThreeDSecureType = keyMirror({
    Payment: null,
    Authorization: null,
});

const with3DSecure = type => WrappedComponent => {
    const _getStateFromStores = () => ({
        currentOrder: OrderStore.getCurrent(),
        is3DSecure: PaymentStore.is3DSecure(),
    });

    @connectToStores([OrderStore, PaymentStore], _getStateFromStores)
    class With3DSecure extends React.PureComponent {
        static propTypes = {
            currentOrder: PropTypes.instanceOf(Order).isRequired,
        };

        _handle3DSComplete = (handlePaymentComplete, options) => () => {
            if (options) {
                // handle keyGo here
                if (options.isKeyGo) {
                    handlePaymentComplete({ justReset3D: true });
                }
                if (options.isKeyGoRegistration) {
                    CustomerActions.registerKeyGoResume(options.user, options.threeDSecureAuthResponse.cocs.id);
                } else {
                    // can only be registration or update
                    CustomerActions.updateKeyGoResume(options.user, options.threeDSecureAuthResponse.cocs.id);
                }
                if (options && options.successCallback) {
                    options.successCallback();
                }
            } else {
                OrderActions.refresh(this.props.currentOrder).then(handlePaymentComplete);
            }
        };

        _getThreeDSecureProps = (authResponse, handler, opts) => {
            const { host } = window.location;
            const callbackUrl = config.get('threeDSecureCallbackUrl');
            const threeDSecureTermUrl = config.get(`threeDSecureTermUrl${
                authResponse.cocs.threeDSServerTransId ? 'V2' : 'V1'
            }${type}`);

            switch (type) {
                case ThreeDSecureType.Payment: {
                    return {
                        authResponse: authResponse.cocs,
                        onComplete: this._handle3DSComplete(handler, opts),
                        responseUrl: makeUrl(
                            threeDSecureTermUrl
                                .replace('{orderId}', this.props.currentOrder.id)
                                .replace('{paymentId}', authResponse.id)
                                .replace('{deviceToken}', TokenStore.getDevice())
                                .replace('{callbackUrl}', `https://${host}${callbackUrl}`),
                        ),
                    };
                }

                case ThreeDSecureType.Authorization: {
                    return {
                        authResponse: authResponse.cocs,
                        onComplete: this._handle3DSComplete(handler, opts),
                        responseUrl: makeUrl(
                            threeDSecureTermUrl
                                .replace('{paymentId}', authResponse.id)
                                .replace('{callbackUrl}', `https://${host}${callbackUrl}`),
                        ),
                    };
                }

                default: {
                    return null;
                }
            }
        };

        render() {
            const injectedProps = {
                handle3DSComplete: this._handle3DSComplete,
                renderThreeDSecure: (...props) =>
                    <ThreeDSecure {...this._getThreeDSecureProps(...props)} />,
            };

            return <WrappedComponent {...injectedProps} {...this.props} />;
        }
    }

    With3DSecure.displayName = `With3DSecure(${WrappedComponent.displayName ||
        WrappedComponent.name ||
        'Component'})`;

    return With3DSecure;
};

export default with3DSecure;



// WEBPACK FOOTER //
// ./src/components/checkout/payment/with3DSecure.js